// extracted by mini-css-extract-plugin
export default {"container":"JobScreen_container__lvGAh","job":"JobScreen_job__AwxAb","content":"JobScreen_content__PVH4E"};